// extracted by mini-css-extract-plugin
export default {"size":"TermsAndCondition_size__Sb3tc"};